import React from 'react';
import {
  FaFacebookF,
  FaInstagram,
  FaYoutube,
  FaWhatsapp,
} from 'react-icons/fa';
import { FiMapPin, FiPhone, FiMail } from 'react-icons/fi';
import Logo from '../Logo/Logo';
import Reveal from '../Reveal/Reveal';
import { CONTACT } from '../../data/content';
import '../../styles/footer.css';

const QUICK_LINKS = [
  { id: 'home', label: 'Home' },
  { id: 'about', label: 'About' },
  { id: 'why', label: 'Why Us' },
  { id: 'process', label: 'Process' },
  { id: 'certification', label: 'Certification' },
  { id: 'stories', label: 'Gallery' },
  { id: 'contact', label: 'Contact' },
];

const scrollTo = (id) => (e) => {
  e.preventDefault();
  document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
};

export default function Footer() {
  return (
    <footer className="footer">
      <div className="container footer__grid">
        <Reveal className="footer__col footer__brand">
          <Logo variant="light" showMark={false} showTamil={false} />
          <p>
            Naturally grown vegetables, fruits, grains and traditional farm
            products — delivered fresh while preserving nature.
          </p>
          <div className="footer__social">
            <a href="https://facebook.com" aria-label="Facebook" target="_blank" rel="noreferrer">
              <FaFacebookF />
            </a>
            <a href="https://www.instagram.com/mahizhnaturalfarm/" aria-label="Instagram" target="_blank" rel="noreferrer">
              <FaInstagram />
            </a>
            <a href="https://www.youtube.com/@MahizhNaturalFarming" aria-label="YouTube" target="_blank" rel="noreferrer">
              <FaYoutube />
            </a>
            <a href={`https://wa.me/${CONTACT.whatsapp}`} aria-label="WhatsApp" target="_blank" rel="noreferrer">
              <FaWhatsapp />
            </a>
          </div>
        </Reveal>

        <Reveal delay={1} className="footer__col">
          <h4>Quick Links</h4>
          <ul>
            {QUICK_LINKS.map((l) => (
              <li key={l.id}>
                <a href={`#${l.id}`} onClick={scrollTo(l.id)}>
                  {l.label}
                </a>
              </li>
            ))}
          </ul>
        </Reveal>

        <Reveal delay={2} className="footer__col">
          <h4>Contact</h4>
          <ul className="footer__contact">
            <li>
              <FiMapPin /> <span>{CONTACT.address}</span>
            </li>
            <li>
              <FiPhone />{' '}
              <span>
                <a href={CONTACT.phoneHref}>{CONTACT.phone}</a>
                <br />
                <a href={CONTACT.phone2Href}>{CONTACT.phone2}</a>
              </span>
            </li>
            <li>
              <FiMail /> <a href={`mailto:${CONTACT.email}`}>{CONTACT.email}</a>
            </li>
          </ul>
        </Reveal>
      </div>

      <div className="footer__bar">
        <div className="container">
          <p>
            © 2026 Mahizh Natural Farming. All Rights Reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
